export default [
  {
    path: '/whd_homepage',
    component: resolve => require(['./WhdHomepage.vue'], resolve),
    name: 'whd_homepage',
    leaf: true//只有一个节点
  }
]
